import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FfdNoteItem } from '@libs/ffd-notes';
import { TagEvent, TagPusherService } from '@libs/shared-services';
import { FfdNoteComponent } from '../ffd-note';

@Component({
  selector: 'lib-ffd-notes-detail',
  imports: [CommonModule, TranslateModule, FfdNoteComponent],
  templateUrl: './ffd-notes-detail.component.html',
  styleUrl: './ffd-notes-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FfdNotesDetailComponent {
  private readonly tagPusherService = inject(TagPusherService);

  public activeNoteItem = input<FfdNoteItem | null>(null);
  public editedNoteId = input<string | null>(null);
  public searchTerm = input<string | null>(null);
  public selectedNoteId = input<string | null>(null);
  public isNoteSaving = input<boolean>(false);
  public isNoteSaved = input<boolean>(false);

  public noteClick = output<string>();
  public noteEdit = output<string | null>();
  public noteSave = output<FfdNoteItem>();
  public deleteNote = output<string>();

  protected onNoteClick(note: FfdNoteItem): void {
    this.noteClick.emit(note.id);
  }

  protected onToggleEditMode(note: FfdNoteItem): void {
    if (this.editedNoteId()) {
      this.noteEdit.emit(null);
    } else {
      this.tagPusherService.pushTag({
        event: TagEvent.FfdNotesNoteEdit,
        location: 'note_details',
      });
      this.noteEdit.emit(note.id);
    }
  }

  protected onNoteSave(saveData: FfdNoteItem): void {
    this.noteSave.emit(saveData);
  }

  protected onDeleteNote(noteId: string): void {
    this.tagPusherService.pushTag({
      event: TagEvent.FfdNotesNoteDelete,
      location: 'note_details',
    });
    this.deleteNote.emit(noteId);
  }
}
